module.exports = __webpack_public_path__ + "static/img/06.79d9c0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bio/06.jpg
// module id = /6RF
// module chunks = 0